module.exports = __webpack_public_path__ + "img/HZ3605-193.e46378cb.jpg";